import React, {useState} from "react";
import { Pagination } from "@components";
import { Input,  Select } from "@components/form";
import {  FormProvider } from 'react-hook-form';
import { useParams} from "react-router-dom";
import { useLectureApply } from "@hooks";
import { useQueryClient } from '@tanstack/react-query';
import {LectureApplyHistoryModal} from "./LectureApplyHistoryModal";
import LectureTabNav from './LectureTabNav';


const LectureApply = () => {
  const { lectureId } = useParams();
  const [selectedKey, setSelectedKey] = useState(null); 

  const {
    methods, data, onSubmit,
    handlePageChange, handleApprove, handleReject, handleCancel, resetSearch,
    pageIndex, recordCountPerPage,
  } = useLectureApply(lectureId);

  const [formModalOpen, setFormModalOpen] = useState(false);
  const queryClient = useQueryClient();

  const handleHistory = (e) => {
    e.preventDefault();
    setFormModalOpen(true);
  };


  const renderActionButtons = (row) => {
    switch (row.applyStatus) {
      case 'A':   // 승인대기
        return (
          <>
          <div className="table-list-btn">
              <button
                type="button"
                className="btn-approve"
                onClick={() => handleApprove(row, data?.curCnt)}
              >
                승인
              </button>
              <button
                type="button"
                className="btn-save ml10"
                onClick={() => handleReject(row)}
              >
                반려
              </button>
          </div>    
          </>
        );
  
      case 'B':   // 승인 완료
        return (
          <div className="table-list-btn">
            <button
              type="button"
              className="btn-normal"
              onClick={() => handleCancel(row)}
            >
              승인취소
            </button>
          </div>
        );
  
      default:    // C·N·R
        return null;
    }
  };


  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
        <LectureTabNav lectureId={lectureId} active="apply" />
          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item">
                    <label>조회 조건</label>
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "아이디" },
                        { key: "1", name: "이름" },
                        { key: "2", name: "소속회사" },
                      ]}
                      defaultOption="전체"
                      className="input-select"
                    />
                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "300px" }}
                    />
                  </div>
                  <div className="search-btn-container">
                    <button type="submit" className="btn-search">조회</button>
                    <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
                  </div>
                </div>
              </div>
                <section className="section-wrap">
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;수강생 신청 목록
                      <span className="total-txt" style={{fontWeight:"bold"}}>
                        {" "} | 현재 강의 정원 <span className="red" style={{fontWeight:"bold", fontSize:"1.0rem"}} >{data?.curCnt.curStudentCnt} / {data?.curCnt.eduStdntLimit}</span> 
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><button type="button" className="btn-update"  onClick={handleHistory}>수강생관리이력</button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-container">
                    <div className="table-box">
                    <table className="table-list" style={{width:"100%"}}>
                      <colgroup>
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "10%" }} />
                        {/* <col style={{ width: "5%" }} /> */}
                        {/* <col style={{ width: "15%" }} /> */}
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "10%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th>번호</th>
                          <th>아이디</th>
                          <th>이름</th>
                          <th>전화번호</th>
                          <th>소속회사</th>
                          {/* <th>세금계산서담당자</th> */}
                          {/* <th>담당자이메일</th> */}
                          <th>신청일</th>
                          <th>결제방법</th>
                          <th>입금자명</th>
                          <th>대기번호</th>
                          <th>신청상태</th>
                          <th>관리</th>
                        </tr>
                      </thead>
                      <tbody>
                      {data?.resultList && data.resultList.length > 0 ? (
                        data.resultList.map((item, idx) => {
                          const rowKey = `${item.lectureId}-${item.memberId}`;
                          return (
                            <tr 
                                key={rowKey}
                                onClick={() => setSelectedKey(rowKey)}
                                className={selectedKey === rowKey ? 'row-selected' : ''}
                                style={{ cursor: 'pointer' }}
                            >
                              <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                              <td style={{textAlign:"center"}}>{item.memberId}</td>
                              <td>{item.memberNm}</td>
                              <td>{item.phoneNo}</td>
                              <td>{item.companyNm}</td>
                              {/* <td>{item.taxMgrNm}</td> */}
                              {/* <td>{item.taxMgrEmail}</td> */}
                              <td>{item.applyDt}</td>
                              <td>{item.payType === 'A' ? '무통장입금' : item.payType === 'B' ? '현장결제' : '카드결제'}</td>
                              <td>{item.depositName ? item.depositName : "-"}</td>
                              <td><span style={{fontWeight:"bold"}}>{item.applyNo}</span></td>
                              <td><span style={{fontWeight:"bold"}}>{item.applyStatusNm}</span></td>
                              <td>{renderActionButtons(item)}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={9} style={{ textAlign: 'center' }}>
                            조회 결과가 없습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    </table>
                    </div>
                  </div>
                    {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                    <Pagination
                        totalPages={Math.ceil(
                          data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                        )}
                        currentPage={pageIndex}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={10}
                    />
                    )}
                </section>
            </div>
          </div>
        </div>
      </form>
      <LectureApplyHistoryModal
        isOpen={formModalOpen}
        onClose={() => setFormModalOpen(false)}
        lectureId={lectureId}
      />

    </FormProvider>
    
  );
};

export {LectureApply};
